import type { StyleLayer } from './utils/types'

export const layers_parkingTilda_street_surface: StyleLayer[] = [
  {
    id: 'street_surface',
    type: 'line',
    filter: ['has', 'capacity'],
    paint: {
      'line-color': [
        'case',
        [
          'match',
          ['get', 'surface'],
          [
            'ground',
            'grass_paver',
            'compacted',
            'grass',
            'fine_gravel',
            'gravel',
            'sand',
            'unpaved',
            'woodchips',
          ],
          true,
          false,
        ],
        'hsl(142, 94%, 40%)',
        [
          'match',
          ['get', 'surface'],
          [
            'concrete',
            'concrete:plates',
            'asphalt',
            'bricks',
            'metal',
            'metal_grid',
            'paved',
            'plastic',
            'rubber',
            'wood',
          ],
          true,
          false,
        ],
        'hsl(344, 93%, 35%)',
        [
          'match',
          ['get', 'surface'],
          [
            'cobblestone',
            'sett',
            'paving_stones',
            'large_sett',
            'mosaic_sett',
            'pebblestone',
            'small_sett',
            'stone',
          ],
          true,
          false,
        ],
        'hsl(164, 92%, 42%)',
        ['has', 'surface'],
        'hsl(280, 94%, 63%)',
        'rgb(199, 199, 199)',
      ],
      'line-opacity': ['case', ['match', ['get', 'staggered'], ['yes'], true, false], 0.5, 1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 15, 2, 20, 16],
    },
  },
]
